export default __webpack_public_path__ + "static/img3-00489a9f35b4824ba311f9ce2a561fab.jpg";